import classNames from 'classnames'
import React from 'react'
import { Button } from './..'
import { Exclamation } from '../Svg'
import styles from './InfoButton.module.scss'

export interface InfoButtonProps {
  className?: string
  onClick?: () => void
}

const InfoButton = ({ className, onClick, ...restProps }: InfoButtonProps) => (
  <Button
    type='button'
    iconStart={Exclamation}
    onClick={onClick}
    className={classNames(styles.infoButton, className)}
    {...restProps}
  />
)

export default InfoButton
